import { productGroup, priceDescr } from 'c9-tracking';
import { EMAIL_EVENT } from '../interface/IPayload';
import { ECoverages, FLOW, IContactInfo, IQuoteInfo, IAppProviderState, YES_NO } from '../interface/IAppProvider';
import { WhitelabelPartner } from '../interface/IAppConfig';
import officeWorkerCoveragesAttributes from '../../assets/json/officeWorkerCoveragesConfig.json';

const initialState: IAppProviderState = {
    product: {
        monthlyPrice: 0,
        chosenCoverages: [
            { name: ECoverages.Prof, selected: false },
            { name: ECoverages.Cyber, selected: false },
            { name: ECoverages.GDPR, selected: false },
            { name: ECoverages.OccupationalInjury, selected: false },
        ],
        possibleCoverages: [
            { name: ECoverages.Prof, selected: true },
            { name: ECoverages.Cyber, selected: true },
            { name: ECoverages.GDPR, selected: true },
            { name: ECoverages.OccupationalInjury, selected: false },
        ],
        van: false,
    },
    salesComplete: false,
    cvrData: {
        name: '',
        address: '',
        zipcodeAndCity: '',
        cvrNumber: '',
        employees: 0, // always an int
        employeesStr: '', // can be a float
        business: {
            key: '',
            name: '',
            form: {
                short: '',
                long: '',
                code: 0,
            },
        },
        businessLine: '',
    },
    lockinPeriod: 5,
    turnover: undefined,
    bankInfo: {
        regNumber: '',
        accNumber: '',
        hasPbsContract: false,
    },
    eCommerceProduct: {
        name: 'erhvervsforsikringer',
        id: 'erhvervsforsikringer',
        group: productGroup.insurance,
        price: 0,
        priceDescr: priceDescr.monthly,
        excess: 0,
        coverages: [
            { name: ECoverages.Prof, value: 0 },
            { name: ECoverages.Cyber, value: 0 },
            { name: ECoverages.GDPR, value: 0 },
        ],
        criteria: [
            { name: 'db07', value: '' },
            { name: 'employees', value: 0 },
            { name: 'duration', value: 0 },
        ],
    },
    terms: null,
    contactInfo: {
        name: '',
        addr: '',
        phone: '',
        email: '',
        insuranceAddress: undefined,
        sameAddress: YES_NO.DONT_KNOW,
    } as IContactInfo,
    quote: {
        company: '',
        cvrNumber: '',
        name: '',
        phone: '',
        email: '',
        remarks: '',
        condition: EMAIL_EVENT.UNKNOWN,
    } as IQuoteInfo,
    inception: {
        currently: YES_NO.DONT_KNOW,
        date: '',
    },
    claimHistory: {
        noOfClaims: undefined,
        claimHistory: undefined,
        terminationTerms: undefined,
    },
    hasError: { stepOne: false, stepTwo: false, separateCallMe: false },
    initialState: true,
    stateChange: false,
    isLoading: false,
    emailSent: false,
    emailEvent: EMAIL_EVENT.UNKNOWN,
    refreshFromCache: false,
    flow: FLOW.BUY,
    attributes: officeWorkerCoveragesAttributes,
    actualStep: 1,
    previousStep: 1,
    selectedPackage: { packageName: '', monthlyPrice: 0, coverages: [], totalMonthlyPrice: 0 },
    partner: WhitelabelPartner.NONE,
    partnerDiscount: { percent: NaN, amount: NaN },
    validReceiptRedirection: false,
    haveOtherIndustry: undefined,
    hasManyOwner: undefined,
    cpr: '',
    isHideOccupationalInjury: false,
};
export default initialState;
